import styled, { css } from 'styled-components';
import { Clickable } from 'src/components/clickable';
import { layout } from 'src/components/base';

export const SharedListItemStyles = css`
  display: flex;
  align-items: center;
  padding: ${layout.measurements.spacing050};
  cursor: pointer;
  width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${p => p.theme.text.primary};
  &:disabled {
    color: rgba(16, 16, 16, 0.3);
  }

  svg {
    margin-right: ${layout.measurements.spacing050};
  }

  &:hover {
    background: ${p => p.theme.dropdowns.secondary.hoverBackground};
  }
`;

export const ListItem = styled(Clickable)`
  ${SharedListItemStyles};
`;
